import React from 'react';
import PropTypes from 'prop-types';

import { PrimaryButton } from 'v-c/Buttons/Components';

import { FormLabel, FormText, InputField, FormErrorText } from 'v-c/Forms';

import passwordValidator from 'component-utilities/passwordValidator/passwordValidator';

import styles from './tabs.scss';

const validator = passwordValidator({
    withValidChars: true,
});

const BASE_KEY = 'components.templates.edit_user';

export default function PasswordTab(props) {
    const {
        reactForm: { fields },
        getMessage,
        isNewUserForm,
        isChangePasswordForm,
        validators,
        onSave,
        status,
    } = props;
    const { PasswordComplexityHint } = validator;
    const localizedError = path => getMessage(`${BASE_KEY}.${path}`).toUpperCase();

    return (
        <div className={`password-section ${styles['accordion-content']}`}>
            {!isNewUserForm && (
                <data>
                    <div className={styles['tab-content-column']}>
                        <div className={styles['form-row']}>
                            <FormLabel required>
                                {getMessage(`${BASE_KEY}.password`)}
                            </FormLabel>
                            <div className={styles['medium-input']}>
                                <InputField
                                    type="password"
                                    data-field="password"
                                    {...fields.password}
                                    status={status}
                                />
                            </div>
                            <FormErrorText
                                field="password-form-error"
                                error={validators.password}
                                values={{
                                    field: localizedError('password'),
                                    matchField: localizedError('confirm_password'),
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles['tab-content-column']}>
                        <div className={styles['form-row']}>
                            <FormLabel required>
                                {getMessage(`${BASE_KEY}.confirm_password`)}
                            </FormLabel>
                            <div className={styles['medium-input']}>
                                <InputField
                                    type="password"
                                    data-field="confirm-password"
                                    {...fields.confirmPassword}
                                    status={status}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ clear: 'left' }} />
                    <div className={styles['form-row']}>
                        <FormText>
                            <PasswordComplexityHint />
                        </FormText>
                    </div>
                </data>
            )}
            {isNewUserForm && <FormText>
                {getMessage(`${BASE_KEY}.no_password_text`)}
            </FormText>}
            {isChangePasswordForm && (
                <PrimaryButton
                    data-action="change-password"
                    onClick={onSave}
                    disabled={!!validators.password}
                >
                    {getMessage('components.buttons.save')}
                </PrimaryButton>
            )}
        </div>
    );
}

PasswordTab.propTypes = {
    reactForm: PropTypes.shape({
        fields: PropTypes.object.isRequired,
    }).isRequired,
    getMessage: PropTypes.func.isRequired,
    isNewUserForm: PropTypes.bool.isRequired,
    isChangePasswordForm: PropTypes.bool.isRequired,
    validators: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
};
